var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      staticClass: "custom-multiselect-style",
      attrs: {
        spinnerCentered: "",
        hasData: !!_vm.users,
        loading: _vm.$apollo.queries.users.loading,
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "custom-multiselect-style placeholder-italic customFullWidthInput",
        },
        [
          _c("multiselect", {
            attrs: {
              "track-by": "id",
              placeholder: "Select user",
              value: _vm.user,
              options: _vm.users,
              "custom-label": _vm.fullname,
              "select-label": "",
              "deselect-label": "",
              "selected-label": "",
            },
            on: {
              input: (v) => _vm.$emit("input", v),
              "search-change": (v) => (_vm.usersSearchString = v.trim()),
            },
            scopedSlots: _vm._u([
              {
                key: "singleLabel",
                fn: function ({ option }) {
                  return [
                    option
                      ? _c("TableAvatar", {
                          attrs: {
                            image: option.avatar,
                            title: _vm.fullname(option),
                            initial: _vm.initials(option),
                            avatarClasses: "w-6 h-6 blueBg",
                            primary: "",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "option",
                fn: function ({ option }) {
                  return [
                    option
                      ? _c("TableAvatar", {
                          attrs: {
                            image: option.avatar,
                            title: _vm.fullname(option),
                            avatarClasses: "w-6 h-6 blueBg text-white",
                            primary: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "initial",
                                fn: function ({ defaultClasses }) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "avatar",
                                        class: defaultClasses,
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-sm leading-none",
                                          },
                                          [_vm._v(_vm._s(_vm.initials(option)))]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }